(function ($, undefined) {
	'use strict';
	var isLocal = window.location.hostname === 'localhost';
	var isDev = isLocal || window.location.hostname.includes('dev') || /\b\w+-d\./.test(window.location.hostname);
	var UPLOAD_KEY = isDev ? 'dev-location-data/' : 'location-data/';
	var lang;
	var utils;
	var formValidator;
	let newQuestions = [];
	const REMINDER_DATA_JOINING_CHARACTER = "::";

	var init = function () {
		formValidator = Fw.component.models().form;
		utils = Fw.component.models().utils;
		lang = $("html").attr('lang');

		$(document).on("select2:select", ".updated-select-input[name='response-type']", onReponseTypeChange);
		$("#saveResponseOptBtn").on("click", onSaveBtnClicked);
		$(document).on("click", ".add-response-delete-location", function (e) {
			$(e.currentTarget).parent().parent().remove();
		});

		$(document).on("click", ".add-picture-delete-location", function (e) {
			$(e.currentTarget).parent().parent().remove();
		});

		$(".close-modal-up").on("click", (e) => { $("#" + $(e.currentTarget).attr("modal-id")).toggleClass("show-modal"); });
		$(".save-picture-btn").on("click", onUploadImage);

		$('.checklist-form-question__edit-btn').on('click', onEditChecklistQuestionClick);
		$('.checklist-form-question_save-btn').on('click', onSaveQuestionForm);
		$('.checklist-form-question__delete-btn').on('click', onDeleteChecklistQuestion);
		$('.checklist-add-question-btn').on('click', onChecklistAddQuestionBtnClick);
		$('.checklist-form-question__form [name^=nfc-validation]').on('change', onChecklistFormNFCValidationChange);
		$('[name=checklist-is-generic]').on('change', onChecklistGenericCheckboxChange);
		$(document).on('select2:select', '[name=nfc-tag]', onNFCTagSelectChange);
		$('#add-checklist-location-input').on('change', onChecklistLocationInputChange);
		$('.checklist-save-btn').on('click', onSaveChecklistBtnClick);
		$('.js-nfc-list-item-delete').on('click', window.parent.onRemoveNFCClick);

		$('.reminder-email-block__delete-btn').on('click', onDeleteReminderEmailBlock);
		$('.js-reminder-add-email-block-btn').on('click', onAddReminderEmailBlock);
		$('#checklist-questions-update').on('click', onUpdateClick);

		$('.checklist-form-questions-container').sortable({
			items: '> .checklist-form-question:not(.checklist-form-question_template)',
			handle: '.checklist-form-question__drag-btn',
			cancel: 'input, select',
			cursor: 'grabbing',
			placeholder: "checklist-form-question__drag-placeholder",
			helper: "clone",
			stop: function (event, ui) {
				updateChecklistQuestionIndexes($(ui.item));
			}
		});

		checkNewQuestions();

		var locId = getUrlParam("locationId");

		if ($('#add-checklist-location-input').find("option").length > 1) {
			var selected = $('#add-checklist-location-input').find(":selected").val();
			populateButtonsSelect(selected, false, selectButtonWithChecklistId);
		} else if (locId != null && locId != undefined && locId != "") {
			populateButtonsSelect(locId, false, selectButtonWithChecklistId);
		}
	};

	function selectButtonWithChecklistId() {
		const checklistId = getUrlParam("gid");

		if (!checklistId) {
			console.error("gid not found in URL");
			return;
		}

		const domain = window.location.hostname;
		let url = "";

		if (domain === "localhost") {
			url = `http://localhost:9093`;
		} else {
			url = `/dataservice`;
		}

		// Call backend API
		fetch(`${url}/public/get-button-id/${checklistId}`, {
			method: "GET"
		})
			.then(response => {
				if (!response.ok) {
					throw new Error("Failed to fetch button id");
				}
				return response.json();
			})
			.then(data => {
				
				if (data && data.buttonId != null && data.buttonId != undefined && data.buttonId != "" && data.buttonId != "null") {
					$('#add-checklist-button-input').val(data.buttonId).trigger('change');
				}

			})
			.catch(error => {
				console.error("Error:", error);
			});
	}


	function getUrlParam(name) {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get(name);
	}

	function onUploadImage(e) {
		var fileInput = $("#picture-upload-modal").find('input[type=file]');

		var filename = $("#add-picture-name-input").val();
		var filenameLabel = $("#picture-upload-modal").find(".form-input-label>span");

		var btn = $(e.currentTarget);
		var modal = $("#" + btn.attr("modal-id"));

		if (filename && filename.length > 0 && filename.length <= 50 && fileInput[0].files.length > 0 ||
			btn.attr("modal-type") == "edit") {

			filenameLabel.css("color", "#34446e");
			var fileInputClone = fileInput.clone();
			var containerBox = null;

			if (btn.attr("modal-type") == "add") {
				var boxId = window.parent.addPictureComponent(filename, btn.attr("data-id"), null);
				containerBox = $("." + boxId).parent().parent();

				var count = containerBox.parent().find(".picture-container-item").length;
				containerBox.attr("data-id", count > 0 ? count - 1 : count);

				containerBox.append(fileInputClone);
				containerBox.addClass("_edited");
				containerBox.attr("data-json", JSON.stringify({ title: containerBox.find(".first").html(), id: "0", filename: modal.find(".upload-input__placeholder").text() }));
			} else if (btn.attr("modal-type") == "edit") {
				var boxId = btn.attr("data-str-box-id");
				containerBox = $("." + boxId).parent().parent();
				containerBox.addClass("_edited");

				var json = JSON.parse(containerBox.attr("data-json"));
				containerBox.find(".first").html(filename);

				if (fileInput[0] && fileInput[0].files && fileInput[0].files.length > 0) {
					containerBox.find("input").remove();
					containerBox.append(fileInputClone);
					$("#picture-upload-modal").find('input[type=file]').remove();
					containerBox.attr("data-json", JSON.stringify({ title: containerBox.find(".first").html(), id: "0", filename: modal.find(".upload-input__placeholder").text() }));
				} else
					containerBox.attr("data-json", JSON.stringify({ title: containerBox.find(".first").html(), id: json.id, filename: modal.find(".upload-input__placeholder").text() }));
			}

			modal.toggleClass("show-modal");
		} else
			filenameLabel.css("color", "red");
	}

	function onSaveBtnClicked(e) {
		var dropdownOption = $("input[name='dropdownOption']").val();
		var dropdownOptionLabel = $("#dropdownOptionLabel");
		var btn = $(e.currentTarget);
		var modal = $("#" + btn.attr("modal-id"));

		if (dropdownOption && dropdownOption !== undefined && dropdownOption.length > 1) {
			dropdownOptionLabel.css("color", "#34446e");

			if (btn.html() == "Add") {
				var id = window.parent.addComponent(dropdownOption, btn.attr("data-id"));
				// $("#"+id).parent().parent().addClass("_edited");
			} else if (btn.html() == "Update") {
				var boxId = btn.attr("data-str-box-id");
				// $("."+boxId).parent().parent().addClass("_edited");
				$("." + boxId).html(dropdownOption);
			}

			if ($(".incident-dropdown-container .response-type-container-item"))
				$(".incident-dropdown-container .response-type-container-item")
					.sort(function (a, b) {
						if ($(a).find(".first").html() < $(b).find(".first").html()) {
							return -1;
						} else {
							return 1;
						}
					}).appendTo(".incident-dropdown-container");

			var ignoreOption = $(".ingore-it");
			if (ignoreOption) {
				var ignoreOptionClone = ignoreOption.clone();
				ignoreOption.remove();
				$(ignoreOptionClone).appendTo(".containerId" + btn.attr("data-id"));
			}

			modal.toggleClass("show-modal");
		} else {
			dropdownOptionLabel.css("color", "red");
		}
	}

	function onReponseTypeChange(e) {
		var responseType = $(e.currentTarget).find(":selected").val();
		var containerIdParent = $(".containerIdParent" + $(e.currentTarget).attr("data-id"));
		containerIdParent.addClass(responseType == "dropdown" ? "d-block" : "d-none").removeClass(responseType == "dropdown" ? "d-none" : "d-block");
	}

	function checkNewQuestions() {
		let update = document.querySelector('.checklist-form-questions-update');

		if (!update) {
			return;
		}

		utils.fetchGenDatas({ ids: update.dataset.id }, (gd) => {
			let checklist = gd && gd[0] || {};
			let checklistQuestions = checklist.field8 || "{\"questions\":[]}";
			let questions = JSON.parse(sanitizeUserText(checklistQuestions)).questions;
			let tokensInput = document.querySelector('[name="tokens"]');
			let tokens = tokensInput && tokensInput.value || "[]";
			let tokensJSON = JSON.parse(tokens);
			let checklistTokens = checklist.hasOwnProperty("field15") && !!checklist.field15 && checklist.field15 || "[]";
			let newTokens = JSON.parse(checklistTokens).filter(token => tokensJSON.indexOf(token) === -1);

			newQuestions = questions.filter(q => q.token && newTokens.indexOf(q.token) > -1);

			if (newQuestions.length) {
				update.classList.remove('checklist-form-questions-update_hide');
			}
		});
	}

	function onUpdateClick() {
		let update = document.querySelector('.checklist-form-questions-update');
		update.parentNode.removeChild(update);
		newQuestions.forEach(q => {
			let questionItem = $('.checklist-form-question_template').clone(true);
			let tagSelect = $('[name=nfc-tag]', questionItem);
			let index = $('.checklist-form-question').length;
			let token = q.token;

			questionItem.attr('data-token', token);
			questionItem.attr('data-id', index);
			questionItem.attr('data-json', JSON.stringify(q));
			questionItem.removeClass('checklist-form-question_template');
			$('.checklist-form-question__counter p', questionItem).text(index);
			questionItem.insertAfter($('.checklist-form-question').last());

			$('[name="field2"]', questionItem).addClass('required').val(q.name);
			$('[name="field3"]', questionItem).addClass('required').val(q.description);
			$('[name="response-type"]', questionItem).val(q.responseType);

			if (q.pictureOption) {
				$('[name="activate-picture-option"]').prop('checked', true);
			}

			// NOTE (william): It's impossible to get NFC tags from a generic checklist
			// if (q.NFCValidation) {
			// 	duplicateAndPopulateNFC(questionItem);
			// 	$('[name^=nfc-validation][value=yes]', questionItem).prop("checked", true);
			// } else {
			$('[name^=nfc-validation][value=no]', questionItem).prop("checked", true);
			// }

			$('[name^=nfc-validation]', questionItem).attr("name", `nfc-validation-${token}`);

			updateChecklistFormQuestionView(questionItem, q, tagSelect.find(':selected').text(), {});
		});
	}

	function onEditChecklistQuestionClick({ currentTarget }) {
		var btn = $(currentTarget);
		var questionItem = btn.closest('.checklist-form-question');

		questionItem.addClass('checklist-form-question_editing');
		var containerId = questionItem.attr("data-id");
		var jsonStr = questionItem.attr("data-json");
		jsonStr = sanitizeUserText(jsonStr);
		var json = JSON.parse(jsonStr);

		$(".response-type-container-item").remove();

		if (json["responseOptions"] != [] && json["responseOptions"] != undefined && json["responseOptions"] != null) {
			var responseOptions = JSON.parse(json["responseOptions"]);
			if (responseOptions != null && responseOptions != undefined) {
				for (var i = 0; i < responseOptions.length; i++) {
					window.parent.addComponent(responseOptions[i], containerId);
				}
			}
		}

		var pictureContainer = $(".pictureContainerId" + containerId);
		if (pictureContainer.find(".picture-container-item").length <= 0 && json["qPictures"] != [] && json["qPictures"] != undefined && json["qPictures"] != null) {
			var qPictures = JSON.parse(json["qPictures"]);

			for (var i = 0; i < qPictures.length; i++) {
				var qPicture = qPictures[i];

				if (qPicture) {
					var question = window.parent.addPictureComponent(qPicture.title, containerId, qPicture.filename ? qPicture.filename : "-");
					var qV = $("." + question).parent().parent();
					qV.attr("data-json", JSON.stringify(qPicture));
					var count = qV.parent().find(".picture-container-item").length;
					qV.attr("data-id", count > 0 ? count - 1 : count);
				}
			}
		}
	}

	function onSaveQuestionForm({ currentTarget }) {
		var btn = $(currentTarget);
		var questionItem = btn.closest('.checklist-form-question');

		formValidator.validateForm(questionItem);

		if (!questionItem.hasClass('has-error')) {
			var isSaved = presaveChecklistQuestionForm($('.checklist-form-question__form', questionItem));
			if (isSaved) {
				questionItem.removeClass('checklist-form-question_editing');
			}
		}
	}

	function onDeleteChecklistQuestion({ currentTarget }) {
		var btn = $(currentTarget);
		var questionItem = btn.closest('.checklist-form-question');
		questionItem.remove();

		updateChecklistQuestionIndexes();
	}

	function onChecklistAddQuestionBtnClick({ currentTarget }) {
		let btn = $(currentTarget);
		let questionItem = $('.checklist-form-question_template').clone(true);
		let index = $('.checklist-form-question').length;
		let token = utils.generateToken();

		questionItem.attr('data-token', token);
		questionItem.attr('data-id', index);
		questionItem.addClass('checklist-form-question_editing').removeClass('checklist-form-question_template');
		$('.checklist-form-question__counter p', questionItem).text(index);
		questionItem.insertAfter($('.checklist-form-question').last());
		$('[name=field2], [name=field3]', questionItem).addClass('required');
		$('[name^=nfc-validation][value=no]', questionItem).prop("checked", true);
		$('[name^=nfc-validation]', questionItem).attr("name", `nfc-validation-${token}`);

		questionItem.find(".dropdown-response-container").find("button").attr("data-id", index);
		questionItem.find(".dropdown-response-container").removeClass("containerIdParent1").addClass("containerIdParent" + index);
		questionItem.find(".dropdown-response-container-inner").removeClass("containerId1").addClass("containerId" + index);
		questionItem.find(".response-type-container-item").remove();

		questionItem.find(".pictures-container").find("button").attr("data-id", index);
		questionItem.find(".pictures-container").removeClass("pictureContainerIdParent1").addClass("pictureContainerIdParent" + index);
		questionItem.find(".pictures-container-inner").removeClass("pictureContainerId1").addClass("pictureContainerId" + index);
		questionItem.find(".picture-container-item").remove();
		questionItem.find("[name='response-type']").attr("data-id", index);
		questionItem.find(".nfc-popup-btn").attr("data-target-selector", ".checklist-form-question[data-id='" + index + "'] select[name='nfc-tag']");
		window.parent.updateHiddenSelect2(questionItem, (Math.floor(Math.random() * 10000000)));
	}

	function onChecklistFormNFCValidationChange({ currentTarget }) {
		var input = $(currentTarget);
		var form = input.closest('.checklist-form-question__form');
		var select = $('[name="nfc-tag"]', form);
		select.removeClass('error');

		$('.checklist-form-question__nfc-infos', form).toggleClass('checklist-form-question__nfc-infos_visible', input.is(':checked') && input.val() == "yes");

		if (input.prop('checked') && input.val() === 'no') {
			select.val('');
		}
	}

	function onChecklistGenericCheckboxChange({ currentTarget }) {
		var locationInput = $('[name=checklist-location]');
		var ctn = locationInput.closest('.form-select-ctn');
		const nfcContainers = $('.checklist-form-question__nfc-ctn');
		if (currentTarget.checked) {
			ctn.addClass('hide-visibility');
			nfcContainers.addClass('checklist-form-question__nfc-ctn_hide');
			locationInput.removeClass('required');
			locationInput.val("");
			nfcContainers.find('select').attr('disabled', 'disabled');
			removeNFCFromQuestionsData();
		} else {
			ctn.removeClass('hide-visibility');
			locationInput.addClass('required');
			nfcContainers.removeClass('checklist-form-question__nfc-ctn_hide');
			nfcContainers.find('select').removeAttr('disabled', 'disabled');
		}

		populateButtonsSelect("", true);
	}

	function removeNFCFromQuestionsData() {
		$('.checklist-form-question:not(.checklist-form-question_template)').each((i, el) => {
			$('[name^=nfc-validation][value=no]', el).prop('checked', true).trigger('change');
			$('.checklist-form-question_save-btn', el).trigger('click');
		});
	}

	function onNFCTagSelectChange({ currentTarget }) {
		let $ctn = $(currentTarget).closest('.checklist-form-question__nfc-infos');
		let id = currentTarget.value;
		let text = currentTarget.options[currentTarget.selectedIndex].text;
		currentTarget.classList.remove('error');
		currentTarget.value = "";

		if (id !== "") {
			let newItem = document.createElement('li');
			newItem.className = "checklist-form-question__nfc-list-item";
			newItem.innerHTML = `<span>${text}</span><button type="button" class="js-nfc-list-item-delete" data-id="${id}">x</button>`;
			$('button', newItem).on('click', window.parent.onRemoveNFCClick);
			$ctn.find('ul').append(newItem);

			// window.parent.addNFCInInput(id,$ctn);
		}
		window.parent.updateNFCSelects();
	}

	function onChecklistLocationInputChange({ currentTarget }) {
		populateButtonsSelect(currentTarget.value);
	}

	function updateChecklistQuestionIndexes() {
		$('.checklist-form-question').each((i, el) => {
			$(el).find('.checklist-form-question__counter p').text(i);
			$(el).attr('data-id', i);
		});
	}

	function presaveChecklistQuestionForm(form) {
		let questionItem = form.closest('.checklist-form-question.checklist-form-question_editing');
		let initialJSON = questionItem.attr('data-json') ? JSON.parse(sanitizeUserText(questionItem.attr('data-json'))) : {};
		let isNFCValidation = $('[name^=nfc-validation]:checked', form).val() == "yes";
		let tagSelect = $('[name="nfc-tag"]', form);
		let tags = $('.js-nfc-list-item-delete', form);
		let tagsText = tags.map((_, el) => el.previousElementSibling.innerText).get().join(', ');

		let data = {
			"name": $('[name=field2]', form).val(),
			"description": $('[name=field3]', form).val(),
			"responseType": $('[name=response-type]', form).val(),
			"pictureOption": $('[name=activate-picture-option]', form).is(":checked"),
			"NFCValidation": $('[name^=nfc-validation]:checked', form).val() == "yes",
			"NFCTag": tags.map((i, el) => el.dataset.id).get().join()
		};

		if (data["responseType"] == "dropdown") {
			var responseOptionElements = questionItem.find(".response-type-container-item>.add-modify-page-inner-item-ctn-location-item__text>.first");
			var responseOptions = [];
			if (responseOptionElements) {
				responseOptionElements.map((i, el) => {
					responseOptions.push(String(el.innerHTML));
				});

				data["responseOptions"] = JSON.stringify(responseOptions);
			}

		} else data["responseOptions"] = JSON.stringify([]);

		var pictureJson = [];
		var qPicturesElements = questionItem.find(".picture-container-item");
		qPicturesElements && qPicturesElements.map((i, el) => {
			var ele = $(el);

			pictureJson.push(ele.attr("data-json"));
		});
		data["qPictures"] = pictureJson;

		if (questionItem.attr('data-token')) {
			data.token = questionItem.attr('data-token');
		}

		questionItem.attr('data-json', JSON.stringify(data));

		if (isNFCValidation && !tagSelect.prop('disabled') && tags.length === 0) {
			tagSelect.addClass('error');
			return false;
		}

		updateChecklistFormQuestionView(questionItem, data, tagsText, initialJSON);
		return true;
	}

	function updateChecklistFormQuestionView(questionItem, data, nfcText, initialData) {
		var view = $('.checklist-form-question__view', questionItem);
		var classPrefix = ".checklist-form-question-view";
		var initialDataHasTag = initialData.hasOwnProperty("NFCTag") && initialData.NFCTag.toString().length > 0;
		var currentDataHasTag = data.hasOwnProperty("NFCTag");

		$(classPrefix + "__name", view).text(data.name);
		$(classPrefix + "__description", view).text(data.description);
		$(classPrefix + "__response-type", view).text(getResponseTypeTextById(data.responseType));
		var activatePictureOptionText = $(classPrefix + "__activate-picture", view);
		if (data.pictureOption) {
			activatePictureOptionText.show();
		} else {
			activatePictureOptionText.hide();
		}

		$(classPrefix + "__nfc-validation", view).text(data.NFCValidation ? (lang == "fr" ? "Oui" : "Yes") : (lang == "fr" ? "Non" : "No"));
		var nfcTagText = $(classPrefix + "__nfc-tag", view);
		if (data.NFCValidation) {
			nfcTagText.show();
			nfcTagText.text(nfcText);
		} else {
			nfcTagText.hide();
		}
	}

	async function onSaveChecklistBtnClick(e) {
		var btn = $(e.currentTarget);
		var form = btn.closest('.add-modify-page-inner');
		formValidator.validateForm(form);
		var hasQuestions = $('.checklist-form-question:not(.checklist-form-question_template)').length > 0;
		var unsavedQuestions = $('.checklist-form-question_editing');
		var showUnsavedQuestionsAlert = unsavedQuestions.length > 0;
		var confirmation = true;
		if (showUnsavedQuestionsAlert) {
			confirmation = confirm(lang == "fr" ?
				"Vous avez des questions non sauvegardÃ©es. Voulez-vous vraiment continuer?" :
				"You have unsaved questions. Do you still wish to continue?");
		}

		e.preventDefault();
		if (!form.hasClass('has-error') && confirmation) {
			var field30 = $('[name=checklist-field30]').val();
			field30 = !isNaN(parseFloat(field30)) && isFinite(field30) ? field30 : 1;
			var params = {
				field1: "checklist",
				field2: $('[name=checklist-name]').val(),
				field3: $('[name=checklist-location]').val(),
				field4: $('[name=checklist-description]').val(),
				field5: $('[name=checklist-button]').val(),
				field30: field30,
				field6: $('[name=checklist-is-generic]').is(':checked'),
				field7: $('[name=checklist-activate]').is(':checked'),
				field8: await gatherChecklistQuestionsJSON(),
				field15: populateTokens(),
				field21: $('[name=excluded-weekday]:checked').map(function(){ return $(this).val(); }).get().join(','),
				ajax: true
			};
			if ($('[name=id]').length > 0 && $('[name=id]').val().length > 0) {
				params.id = $('[name=id]').val();
			}
			saveReminder(params);

			$('.site-overlay').addClass('site-overlay_processing');
			$.ajax({
				url: "/action/manageGenData",
				method: "post",
				data: params,
				success: function (response) {
					if (response.indexOf("success") !== -1) {
						const id = response.trim().split('success-')[1];

						const updateNFC = updateNFCTags(id, params);
						const updateButtonPromise = updateButton(id, params);
						const updateOtherChecklists = updateChecklists(id, params);
						let completedCount = 0;
						let total = 3;
						updateNFC.then(() => {
							redirectOnFinalComplete(++completedCount, total, btn);
						});

						updateButtonPromise.then(() => {
							redirectOnFinalComplete(++completedCount, total, btn);
						});

						updateOtherChecklists.then(() => {
							redirectOnFinalComplete(++completedCount, total, btn);
						});
					} else {
						$('.site-overlay').removeClass('site-overlay_processing');
						// TODO show error message
					}
				}
			});
		}
		else {
			if (!hasQuestions) {
				// TODO show error in questions section
			}
		}
	}

	function populateTokens() {
		let tokensInput = $('[name="tokens"]');
		let tokens = [];

		try {
			tokens = JSON.parse(tokensInput.val());
		} catch (ex) { /* Do nothing */ }

		$('.checklist-form-question').each((i, el) => {
			let { token } = el.dataset;

			if (token && tokens.indexOf(token) == -1) {
				tokens.push(token);
			}
		});

		return JSON.stringify(tokens);
	}

	function redirectOnFinalComplete(current, total, btn) {
		if (current >= total) {
			location.href = btn.attr('data-redirect-url');
		}
	}

	function saveReminder(params) {
		let defaultReminderCtn = document.getElementById('reminder-default');
		let deficienciesReminderCtn = document.getElementById('reminder-if-deficiencies');
		let [field9, field10, field16, field17] = getRemindersInfo(defaultReminderCtn);
		let [field11, field12, field18, field19] = getRemindersInfo(deficienciesReminderCtn);
		let field13 = getReminderContacts(defaultReminderCtn);
		let field20 = getReminderContacts(deficienciesReminderCtn);

		if (field13.length > 0) {
			params.field13 = JSON.stringify({ "contacts": field13 });
		}

		if (field20.length > 0) {
			params.field20 = JSON.stringify({ "contacts": field20 });
		}

		params.field9 = field9;
		params.field10 = field10;
		params.field16 = field16;
		params.field17 = field17;
		params.field11 = field11;
		params.field12 = field12;
		params.field18 = field18;
		params.field19 = field19;
	}

	function getRemindersInfo(ctn) {
		let recurrences = [];
		let times = [];
		let startDates = [];
		let repetitions = [];

		$('.reminder:not(.reminder_template)', ctn).each((i, reminderCtn) => {
			let timeInputCtn = $('.time-am-pm-inputs', reminderCtn);
			let time = `${$('.updated-select-input', timeInputCtn).find(":selected").val()}:00 ${$('[type="radio"]:checked', reminderCtn).val()}`;

			let recurrenceSelect = $('[name="reminder-recurrence"]', reminderCtn);
			window.parent.updateHiddenSelect(recurrenceSelect, null);

			let recurrence = recurrenceSelect.find(":selected").val();
			let prefix;

			switch (recurrence) {
				case "daily":
					prefix = '';
					break;
				case "weekly":
					prefix = $('.for-reminder_weekly input:checked', reminderCtn)
						.map((i, el) => el.value)
						.get()
						.join();
					break;
				default:
					prefix = $(`.for-reminder_${recurrence} .form-input`, reminderCtn).val().replace(/\//g, '-');
					break;
			}

			recurrences.push(recurrence);
			times.push(`${prefix} ${time}`);
			startDates.push($('.input_start-date', reminderCtn).val());
			repetitions.push($('[name="repetition"]', reminderCtn).val());
		});


		return [
			recurrences.join(REMINDER_DATA_JOINING_CHARACTER),
			times.join(REMINDER_DATA_JOINING_CHARACTER),
			startDates.join(REMINDER_DATA_JOINING_CHARACTER),
			repetitions.join(REMINDER_DATA_JOINING_CHARACTER)
		];
	}

	function getReminderContacts(ctn) {
		let reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		let allReminderContacts = [];
		$('.reminder:not(.reminder_template)', ctn).each((i, el) => {
			allReminderContacts.push($('.reminder-email-block', el).filter((i, el) => {
				let name = el.querySelector('[name="reminder-email-name"]');
				let email = el.querySelector('[name="reminder-email-email"]');
				return name.value != '' && email.value != '' && !!email.value.match(reEmail);
			}).map((i, el) => {
				let t = $(el);
				let name = el.querySelector('[name="reminder-email-name"]').value;
				let email = el.querySelector('[name="reminder-email-email"]').value;
				return ({ "name": name, "email": email });
			}).get());
		});
		return allReminderContacts;
	}

	function onDeleteReminderEmailBlock({ currentTarget }) {
		var btn = $(currentTarget);
		var block = btn.closest('.reminder-email-block');
		block.remove();
	}

	function onAddReminderEmailBlock({ currentTarget }) {
		var btn = $(currentTarget);
		var ctn = btn.closest('.reminder');
		var newBlock = $('.reminder-email-block', ctn).first().clone(true);
		$('input', newBlock).val("");
		if (newBlock.find('.reminder-email-block__delete-btn').hasClass('reminder-email-block__delete-btn_hide')) {
			newBlock.find('.reminder-email-block__delete-btn').removeClass('reminder-email-block__delete-btn_hide');
		}
		newBlock.insertAfter($('.reminder-email-block', ctn).last());
	}

	function getQuestions() {
		var pics = $(".picture-container-item");

		return new Promise(async (resolve) => {
			var counter = 0;
			if (!(pics) || pics.length == 0) {
				resolve(pics);
			} else {
				pics.map((i, e) => {
					var ele = $(e);
					var cid = $('[name=id]').length > 0 && $('[name=id]').val().length > 0 ? $('[name=id]').val() : 0;
					var parent = $(e).parent().closest(".checklist-form-question__content").parent();

					var file = ele.find(".upload-input__input");

					if (file != undefined && file[0] != undefined && file[0].files && file[0].files.length > 0) {
						utils.uploadSecureFiles(file[0].files, (response) => {
							const [id, filename] = response.media.mediaIds[0].split(" - ");

							var btnJson = JSON.parse(sanitizeUserText(parent.attr('data-json')));

							if (btnJson["qPictures"]) {
								btnJson["qPictures"][ele.attr("data-id")] = { title: ele.find(".first").html(), id, filename };
							} else {
								btnJson["qPictures"] = [];
								btnJson["qPictures"].push({ title: ele.find(".first").html(), id, filename });
							}

							parent.attr('data-json', JSON.stringify(btnJson));

							counter++;
							if (counter == pics.length) resolve(pics);
						}, parent.attr("data-id"), "q-picture:" + cid, UPLOAD_KEY);
					} else {
						var btnJson = JSON.parse(sanitizeUserText(parent.attr('data-json')));

						if (btnJson["qPictures"]) {
							var jP = JSON.parse(sanitizeUserText(ele.attr("data-json")));
							btnJson["qPictures"][ele.attr("data-id")] = jP;
						} else {
							btnJson["qPictures"] = [];
							btnJson["qPictures"].push(JSON.parse(sanitizeUserText(ele.attr("data-json"))));
						}

						parent.attr('data-json', JSON.stringify(btnJson));
						counter++;
						if (counter == pics.length) resolve(pics);
					}
				});
			}
		}).then((res) => {
			return $('.checklist-form-question[data-json]');
		});
	}

	function sanitizeUserText(str) {
		return str
			.replace(/\r\n/g, "\\n") // normalize CRLF first
			.replace(/\r/g, "\\n")
			.replace(/\n/g, "\\n")
			.replace(/\t/g, "\\t");
	}

	async function gatherChecklistQuestionsJSON() {
		var json = {};

		await getQuestions();
		var questionItems = $('.checklist-form-question[data-json]');;
		var questions = [];

		questionItems.each((i, el) => {
			var q = undefined;
			try {
				let json = sanitizeUserText($(el).attr('data-json'));
				q = JSON.parse(json);
			} catch (error) {
				console.error('Error parsing JSON:', error.message);
			}

			if (q && q["qPictures"]) {
				q["qPictures"] = typeof q["qPictures"] === 'string' ? q["qPictures"] : JSON.stringify(q["qPictures"]);
			}
			if (q)
				questions.push(q);
		});

		json.questions = questions;
		var jsonStr = JSON.stringify(json);

		return jsonStr;
	}

	function getResponseTypeTextById(id) {
		switch (id) {
			case "text": return lang == "fr" ? "Texte" : "Text response";
			case "confirm": return lang == "fr" ? "Confirmation" : "Confirm response";
			case "yes-no": return lang == "fr" ? "Oui/Non" : "Yes/No response";
			// case "yes-no-na": return lang == "fr" ? "Oui/Non/N/A" : "Yes/No/Not Applicable response";
			case "dropdown": return lang == "fr" ? "Réponse déroulante" : "Dropdown Response";
		}
		return "";
	}

	function populateButtonsSelect(id = "", globalOnly = false, callback = null) {
		var buttonsSelect = $('#add-checklist-button-input');
		var fields = { field1: "button", field5: "true", field6: "2" };

		var _complete = function (gendatas) {
			buttonsSelect.find('option:not([value=""])').remove();
			buttonsSelect.append(gendatasToOptions(gendatas));
			buttonsSelect.prop("disabled", false);
			if (callback) callback();
		};

		if (!globalOnly) {
			fields.field15 = id;
		} else {
			fields.field9 = "true";
		}
		buttonsSelect.prop("disabled", true);
		// if (localStorage.getItem(JSON.stringify(fields))) {
		// 	_complete(localStorage.getItem(JSON.stringify(fields)));
		// } 
		// else {
		// FIXME (william): Heavy potential for caching errors. commented for now
		utils.fetchGenDatas(fields, (response) => {
			// localStorage.setItem(JSON.stringify(fields), JSON.stringify(response));
			_complete(response);

		});
		// }
	}

	function gendatasToOptions(gendatasArray = []) {
		var options = "";
		gendatasArray.forEach(gd => {
			options += `<option value="${gd.id}">${decodeCMSEncoding(gd.field2)}</option>`;
		});
		return options;
	}

	function updateNFCTags(id, params) {
		const json = JSON.parse(params.field8);
		let resolveRef;
		const promise = new Promise(resolve => resolveRef = resolve);
		const questions = json.questions.filter(o => o.NFCTag != '');
		const questionCount = questions.length;
		let tagsArray = [];
		let indexArray = [];
		let count = 0;

		if (!questions.length) {
			resolveRef();
		}
		questions.forEach((question, index) => {
			if (question.NFCValidation) {
				try {
					const tagsplit = question.NFCTag.toString().split(',');
					indexArray = indexArray.concat(new Array(tagsplit.length).fill(index));
					tagsArray = tagsArray.concat(tagsplit);
				} catch (err) {
					// NFCTag is undefined or null
				}
			}
		});

		// tagsArray.forEach((tag, i) => {
		//     const data = {
		//         id: tag,
		//         field4: params.field3,
		//         field5: id,
		//         field6: indexArray[i],
		//         field9: true,
		//         ajax: true,
		//     };

		//     $.ajax({
		//         url: '/action/manageGenData',
		//         type: 'POST',
		//         data,
		//         complete: () => {
		//             if (++count >= tagsArray.length) {
		//                 resolveRef();
		//             }
		//         }
		//     });
		// });

		let dataObj = [];
		tagsArray.forEach((tag, i) => {
			dataObj.push({
				id: tag,
				field4: params.field3,
				field5: id,
				field6: indexArray[i],
				field9: true,
				ajax: true,
			});
		});

		if (dataObj != undefined && dataObj != [] && dataObj.length > 0)
			utils.updateGenDatas(dataObj, () => {
				resolveRef();
			});
		else
			resolveRef();

		return promise;
	}

	function updateButton(id, params) {
		let resolveRef;
		const promise = new Promise(resolve => resolveRef = resolve);

		if (params.field5 === '') {
			resolveRef();
		} else {
			$.ajax({
				url: '/action/manageGenData',
				type: 'POST',
				data: {
					id: params.field5,
					field7: id,
					ajax: true,
				},
				complete: () => {
					resolveRef();
				}
			});
		}

		return promise;
	}

	function updateChecklists(id, params) {
		let resolveRef;
		const promise = new Promise(resolve => resolveRef = resolve);

		if (params.field5 === '') {
			resolveRef();
		} else {
			utils.fetchGenDatas({ field5: params.field5 }, (gendatas) => {
				let done = 0;

				function _callback() {
					done++;
					if (done == gendatas.length) {
						resolveRef();
					}
				}

				if (gendatas.length == 0) {
					resolveRef();
				} else {
					gendatas.forEach(checklist => {
						if (id == checklist.id) {
							_callback();
						} else {
							utils.updateGenDataFields(checklist.id, ['field5'], [''], _callback);
						}
					});
				}
			});
		}

		return promise;
	}

	$(window).ready(function () {
		init();
	});
})(jQuery);